<template>
  <div class="loading">
    <div class="content">
      <div class="logo animated"></div>
      <h3 v-if="!noText" class="heading heading-3 primary--text">
        {{ header }}
      </h3>
      <p v-if="!noText" class="sub-heading secondary--text">
        {{ message }}
      </p>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: `PageLoading`,
  props: {
    header: { type: String, default: "Getting Things Ready for You!" },
    message: { type: String, default: "Please wait..." },
    noText: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
@keyframes logotype-slide {
  0% {
    opacity: 0;
    background-position-x: 0px;
    background-size: 40px 30px;
  }

  75% {
    opacity: 1;
  }

  100% {
    background-position-x: 164px;
    background-size: 86px 64px;
    opacity: 0;
  }
}
.loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $white;
  display: grid;
  align-items: center;
  justify-content: center;
  z-index: 10;

  .content {
    text-align: center;
    padding: 0 40px;
    height: 227px;

    .logo {
      background-image: url("data:image/svg+xml;base64,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");
      background-size: 86px 64px;
      background-position-y: center;
      width: 86px;
      height: 64px;
      display: inline-block;

      &.animated {
        width: 250px;
        opacity: 0;
        background-size: 40px 30px;
        background-position-x: 0px 0;
        animation-duration: 1.3s;
        animation-iteration-count: infinite;
        animation-name: logotype-slide;
        animation-timing-function: linear;
      }
    }

    .heading {
      font-weight: $font-weight-extrabold;
      line-height: $line-height-base * 1.66;
      color: $white;
      margin-top: 7px;
      margin-bottom: 0;
      padding: 0 15px;

      @media (max-width: 576px) {
        line-height: $line-height-base * 0.86;
        margin-top: 21px;
      }
    }

    .sub-heading {
      font-weight: $font-weight-semibold;
      font-size: $sh4-font-size;
      line-height: $line-height-base * 0.66;
      letter-spacing: 0.05em;
      text-transform: uppercase;
      color: #419dd7;
      margin-top: 13px;

      @media (max-width: 576px) {
        font-size: $sh5-font-size;
        margin-top: 29px;
      }
    }

    @media (max-width: 576px) {
      height: 267px;
      padding-top: 15px;
    }
  }
}
</style>
